export default __webpack_public_path__ + "static/media/top-k-4-med.a93353b3.jpg";